import type { FaireProductEntity } from "../../entity_types/product";

export const p_zc8shwfck4: FaireProductEntity = {
  token: "p_zc8shwfck4",
  type: "product",
  name: "Fresh Sourdough Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/b14cb027bf4553c8a25dd4c800c4a91e5c96a315e76b9a4f7c68fd71f316cfd1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6212ea993c8e5a1aa5d7131d0e6939f337df73a0c88ed30277ad5950311f2b6f.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:39.816Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
